module.exports = __webpack_public_path__ + "static/img/policyByPlatNo.0445751.png";